import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPersonEnterCatchRide = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 28,
	height: 12,
	viewBox: "0 0 28 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M6 0L11.1962 9H0.803848L6 0Z",
			fill: "#448AFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.1429 11.5H18.8571V4.35L22.8571 0.5L23.5714 1.1875C23.6381 1.25167 23.693 1.33875 23.736 1.44875C23.779 1.55875 23.8004 1.66417 23.8 1.765V1.9575L23.1714 4.35H26.8571C27.1619 4.35 27.4286 4.46 27.6571 4.68C27.8857 4.9 28 5.15667 28 5.45V6.55C28 6.61417 27.9905 6.68292 27.9714 6.75625C27.9524 6.82958 27.9333 6.89833 27.9143 6.9625L26.2 10.84C26.1143 11.0233 25.9714 11.1792 25.7714 11.3075C25.5714 11.4358 25.3619 11.5 25.1429 11.5ZM20 10.4H25.1429L26.8571 6.55V5.45H21.7143L22.4857 2.425L20 4.8175V10.4ZM18.8571 4.35V5.45H17.1429V10.4H18.8571V11.5H16V4.35H18.8571Z",
			fill: "#448AFF"
		})
	]
});
const ForwardRef = forwardRef(SvgPersonEnterCatchRide);
export { ForwardRef as ReactComponent };
